import _ from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import Autosuggest from 'react-autosuggest'

const AutocompletionWithoutListing = ({ value = '', suggestions = [], toShow, onSelect, keepSelection, getSuggestionsAsync }) => {
  const [inputValue, setInputValue] = useState(value)
  const [filteredSuggestions, setFilteredSuggestions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const renderSuggestion = (suggestion) => {
    const displayValue = toShow !== 'fullname' ? suggestion[toShow] : `${suggestion.firstname} ${suggestion.lastname}`
    return <div>{displayValue}</div>
  }

  const getSuggestionValue = (suggestion) => {
    const displayValue = toShow !== 'fullname' ? suggestion[toShow] : `${suggestion.firstname} ${suggestion.lastname}`
    return displayValue
  }

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase()
    if (!inputValue) return []

    setIsLoading(true)
    const newSuggestions = getSuggestionsAsync ? await getSuggestionsAsync(inputValue) : suggestions

    const filtered = newSuggestions.filter((item) => {
      const displayValue = toShow !== 'fullname' ? item[toShow] : `${item.firstname} ${item.lastname}`
      return displayValue && displayValue.toLowerCase().includes(inputValue)
    })

    setFilteredSuggestions(filtered.slice(0, 10))
    setIsLoading(false)
  }

  const debouncedFetch = useMemo(() => _.debounce(getSuggestions, 500), [getSuggestionsAsync])

  useEffect(() => {
    return () => {
      debouncedFetch.cancel()
    }
  }, [debouncedFetch])

  const onChange = (event, { newValue }) => {
    setInputValue(newValue)
  }

  const onSuggestionSelected = (event, { suggestion }) => {
    // Important: d'abord appeler onSelect pour que la sélection soit prise en compte
    if (typeof onSelect === 'function') {
      onSelect(suggestion)
    }

    // Ensuite seulement réinitialiser l'input si nécessaire
    if (!keepSelection) {
      setInputValue('')
    }
  }

  const onSuggestionsFetchRequested = ({ value }) => {
    debouncedFetch(value)
  }

  const onSuggestionsClearRequested = () => {
    setFilteredSuggestions([])
  }

  const inputProps = {
    value: inputValue,
    onChange,
    onInput: (e) => {
      onSuggestionsFetchRequested({ value: e.target.value })
    },
  }

  return (
    <div className="d-flex flex-column">
      <Autosuggest
        suggestions={filteredSuggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
      {isLoading && <div className="loading-spinner" />}
    </div>
  )
}

export default AutocompletionWithoutListing
